import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#6C7072",
      "fill-rule": "evenodd",
      d: "M20.5 0h-15a5 5 0 0 0-5 5v11.25a5 5 0 0 0 5 5h15a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5m-15 1.988h15a3 3 0 0 1 2.875 2.162l-9.425 6.987a1.325 1.325 0 0 1-1.912-.062L2.65 4.163A3 3 0 0 1 5.5 1.986M2.488 16.25A3.01 3.01 0 0 0 5.5 19.262h15a3.01 3.01 0 0 0 3-3.012V6.213l-8.5 6.25a2.94 2.94 0 0 1-2 .787 3.1 3.1 0 0 1-2.075-.838l-8.437-6.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }